export default [
  {
    header: 'อนุมัติรายการคำขอ',
    menu: 'Approve',
  },
  {
    title: 'ค้นหา',
    route: null,
    icon: 'MailIcon',
    menu: 'ApproveSearch',
  },
  {
    title: 'หนังสือรอลงนาม',
    icon: 'CircleIcon',
    route: 'Approve',
    menu: 'ApproveWait',
  },
  // {
  //   title: 'รายงานสรุป',
  //   icon: 'CircleIcon',
  //   route: 'ApproveManage',
  //   menu: 'ApproveSum',
  // },
]
